// Keep the URL alive while mobile browsers hand the PDF to their viewer.
const PDF_URL_LIFETIME_MS = 60000;

export function downloadPdfBlob(blob, filename = "ticket.pdf") {
  if (!blob || !blob.size) throw new Error("The ticket PDF is not ready");
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.target = "_blank";
  link.rel = "noopener";
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), PDF_URL_LIFETIME_MS);
  }
}
